<template>
  <div>
    <div class="mt-3 elevation-12 grey lighten-4">
      <h2 class="px-3 pt-3">{{ $t("newTrip.whichServiceYouWant") }}</h2>
      <v-row class="text-center">
        <v-spacer></v-spacer>
        <v-col cols="12" md="4" class="choose-box elevation-5 fill-height">
          <h3>{{ $t("newTrip.travelServicesOnly") }}</h3>
          <v-icon size="150px">local_grocery_store</v-icon>
          <p>
            {{ $t("newTrip.travelServicesOnlyDescription") }}
          </p>
          <v-btn bottom @click="redirectToBooking()">{{ $t("global.choose") }}</v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" md="4" class="choose-box elevation-5 fill-height"
          ><h3>{{ $t("newTrip.delegationProcess") }}</h3>
          <v-icon size="150px">event_note</v-icon>
          <p>
            {{ $t("newTrip.delegationProcessDescription") }}
          </p>
          <v-btn @click="redirectToDelegation()" bottom>{{ $t("global.choose") }}</v-btn>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </div>
  </div>
</template>

<script>
import wnbAddresses from "../../wnbAddresses";

export default {
  name: "SelectPerson",
  methods: {
    redirectToBooking: function() {
      window.location.href = wnbAddresses("SEARCH");
    },
    redirectToDelegation: function() {
      this.$router.push({ path: "/delegation-order/new" });
    }
  },
  created() {
    if (!this.$store.getters["isWnbUser"]) this.redirectToDelegation(); // TODO ZMIENIC JAK POWSTANIE MODUL DO OFERTOWANIA, POBRAC Z BAZY
  }
};
</script>

<style scoped></style>
